import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('User')
export class User {
  @JsonProperty('id', String, false) id: string = undefined;
  @JsonProperty('email', String, false) email: string = undefined;
  @JsonProperty('enabled', Boolean, false) enabled: boolean = undefined;
  @JsonProperty('roles', [String], false) roles: string[] = undefined;
}
